export const clearUrl = (path, context) => {
  const pathCleared = path.replace(/[a-z]+\/[cp|]\//gi, ''),
    localeIndex = pathCleared.indexOf(`/${context.i18n.locale}/`);

  if (localeIndex === 0) return pathCleared.replace(`/${context.i18n.locale}/`, '');
  else return pathCleared;
}
